import type { FC, ReactNode } from 'react'

import { SplitText } from '@/components/motion/split-text'
import { Reveal } from '@/components/motion/reveal'
import { approachStatement, tenets } from '@/constants/home'

export const HomeApproach: FC = (): ReactNode => {
    return (
        <section
            id='approach'
            className='relative z-[2] flex w-full flex-col items-center gap-16 overflow-clip bg-background px-4 pb-section-lg pt-section-sm lg:gap-20 lg:px-6'
        >
            <div className='flex w-full flex-col md:flex-row md:items-start md:justify-center md:gap-6'>
                <div className='flex w-full flex-col py-6 pr-6 md:max-w-[32%] md:flex-1 md:self-stretch'>
                    <h2 className='t-label max-w-[400px] text-left text-foreground'>
                        The way I work
                    </h2>
                </div>

                <div className='flex w-full flex-col py-6 pr-6 md:flex-1'>
                    <SplitText
                        as='p'
                        text={approachStatement}
                        effect='rise'
                        by='word'
                        stagger={0.01}
                        amount={0.4}
                        className='t-statement w-full max-w-full text-left text-foreground [text-wrap:balance] md:max-w-[90%]'
                    />
                </div>
            </div>

            <div className='flex w-full flex-col md:flex-row md:justify-center md:gap-6'>
                <div aria-hidden='true' className='hidden md:block md:max-w-[32%] md:flex-1' />

                <ol className='grid w-full grid-cols-1 gap-12 md:flex-1 lg:grid-cols-3 lg:gap-10'>
                    {tenets.map((tenet, index) => (
                        <li key={tenet.title} className='min-w-0'>
                            <Reveal delay={index * 0.08} y={20}>
                                <article className='flex flex-col gap-4 border-t border-border pt-6 text-foreground'>
                                    <span className='t-number'>
                                        {tenet.number}
                                    </span>

                                    <h3 className='t-label text-left'>
                                        {tenet.title}
                                    </h3>

                                    <p className='t-body max-w-[420px] text-left text-muted-foreground'>
                                        {tenet.text}
                                    </p>
                                </article>
                            </Reveal>
                        </li>
                    ))}
                </ol>
            </div>
        </section>
    )
}
